// Thin events tracker that POSTs to the unified Supabase `events` table.
// Use `trackEvent(type, data)` from anywhere to log an event with a
// structured payload. Failures are swallowed so analytics never blocks UX.
//
// The `world: 'ian-world'` discriminator scopes rows to this app so the
// same table can be shared across multiple pixel-worlds (caffeine-rush,
// any future neighbor sites). Schema + migration playbook in
// SUPABASE-SETUP.md.

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
const WORLD = 'ian-world';

// Per-tab session id — stable for the lifetime of a tab so we can group
// events from the same visit. sessionStorage clears on tab close.
function getSessionId() {
  try {
    let id = sessionStorage.getItem('iw_session_id');
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem('iw_session_id', id);
    }
    return id;
  } catch {
    return null;
  }
}

export async function trackEvent(type, data = {}) {
  if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
    // Local dev without env vars — just log and skip the insert
    console.debug('[events]', type, data);
    return;
  }
  try {
    await fetch(`${SUPABASE_URL}/rest/v1/events`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: SUPABASE_PUBLISHABLE_KEY,
        Authorization: `Bearer ${SUPABASE_PUBLISHABLE_KEY}`,
        Prefer: 'return=minimal',
      },
      body: JSON.stringify({
        world: WORLD,
        event_type: type,
        event_data: data,
        session_id: getSessionId(),
      }),
    });
  } catch (err) {
    // Best-effort: never block UX on analytics failures
    console.warn('[events] insert failed', err);
  }
}
